var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "-150 0 930 776",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: "87.28%",
    y1: "5.72%",
    x2: "12.88%",
    y2: "94.14%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 388C0 173.048 173.048 0 388 0s388 173.048 388 388-173.04797 388-388 388S0 602.95203 0 388z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.79999 542.59998L426.60001 225.39999c-7.4-16.39999-18.4-24.39999-32.9-24.39999h-11.6c-14.5 0-25.5 8-32.9 24.39999l-57.1 138.20002h-43.20002c-12.89999.1-23.39999 10.5-23.5 23.5v.29998c.10001 12.9 10.60001 23.4 23.5 23.5h23.20002l-54.5 131.69999c-1 2.90002-1.60001 5.90002-1.60001 9 0 7.40002 2.3 13.20001 6.39999 17.70001S232.39999 576 239.8 576c4.90001-.09998 9.59999-1.59998 13.49999-4.5 4.20001-2.90002 7.1-7.09998 9.40002-11.90002l60-148.79999h41.59998c12.90002-.09998 23.40002-10.5 23.5-23.5v-.59998c-.09998-12.90002-10.59998-23.40002-23.5-23.5h-22.19998l45.79998-114.1L512.70001 559.5c2.29999 4.79999 5.20001 9 9.39997 11.90002 3.90002 2.89997 8.70001 4.39997 13.5 4.5 7.40002 0 13.20001-2.20001 17.40002-6.70001s6.40002-10.29999 6.40002-17.70001c.09998-3-.40002-6.09998-1.60003-8.90002z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAave);
export default __webpack_public_path__ + "static/media/aave.e82537ba7dc0813be39d8cf34ff2e16b.svg";
export { ForwardRef as ReactComponent };